/**
 * 로그인 없이 열리는 직독직해 체험 데이터.
 *
 * 홍보용이다. 가입하지 않은 선생님에게 링크 하나만 보내면 **실제 학생 화면 그대로**
 * 눌러볼 수 있어야 한다. 그래서 세션도, 서버 호출도 없이 이 파일의 값만으로 화면을
 * 그린다.
 *
 * **세션을 URL 에 실어 돌리면 안 된다.** 그것은 그 계정의 열쇠라, 받은 사람마다 같은
 * 학생 기록에 겹쳐 쓰고 남의 점수가 서로 보인다. 여기서는 아예 학생을 만들지 않는다.
 * 여럿이 동시에 들어와도 각자의 브라우저 안에서만 돌고 아무것도 남지 않는다.
 */

export const DEMO_SECTION_ID = "demo-direct-translation";

export const DEMO_PARAGRAPH_TITLE = "One day, the king invited everyone...";

const SENTENCE_LIST = [
  [
    "One day, / the king invited everyone / to a grand party / at the palace.",
    "어느 날, / 왕은 모두를 초대했다 / 성대한 파티에 / 궁전에서",
  ],
  [
    "He promised / not to share a secret / with anyone.",
    "그는 약속했다 / 비밀을 말하지 않기로 / 누구에게도",
  ],
];

const WORD_LIST = [
  { eng: "invite", kor: "[동] 초대하다" },
  { eng: "grand", kor: "[형] 성대한, 웅장한" },
  { eng: "palace", kor: "[명] 궁전" },
  { eng: "promise", kor: "[동] 약속하다" },
  { eng: "secret", kor: "[명] 비밀" },
  { eng: "share", kor: "[동] 나누다, 말하다" },
];

/** 학생 화면이 기대하는 모양 그대로 만든다. 서버가 주던 것과 같아야 한다. */
export const buildDemoSectionList = () => [
  {
    id: DEMO_SECTION_ID,
    type: "direct_translation",
    type_name: "",
    is_finished: false,
    answer: [],
    question: {
      data: SENTENCE_LIST,
      words: WORD_LIST,
      mode_list: ["listening", "fluency", "interpretation"],
      reading_unit: "chunk",
      // 체험은 조금 빠르게 읽어 준다. 기본 속도는 어른이 듣기에 늘어진다.
      speech_rate: 1.2,
      is_pronunciation_check_enabled: true,
      // 녹음은 iOS 가 마이크를 인식과 함께 주지 않아 아직 켜지 않는다.
      is_recording_enabled: false,
    },
  },
];

export const buildDemoParagraphList = () => [
  { id: "demo-paragraph", title: DEMO_PARAGRAPH_TITLE, is_finished: false },
];

export const buildDemoAssignment = () => ({
  id: DEMO_SECTION_ID,
  type: "analysis",
  title: "직독직해 체험",
  student_name: "",
  is_finished: false,
  progress_rate: 0,
});
